(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsListStaffBiographiesController', CmsListStaffBiographiesController);

  /* ngInject */
  function CmsListStaffBiographiesController(Flash, cmsStaffBiographyService, cmsStaffBiographiesSettingsService, config, sessionService) {
    const vm = this;

    vm.hasProductRole = sessionService.hasProductRole;
    vm.staffBiographies = [];
    vm.staffBiographiesSettings = {};
    vm.updateStaffBiographiesSettings = updateStaffBiographiesSettings;

    activate();

    function activate() {
      getStaffBiographies();
      getStaffBiographiesSettings();
    }

    function getStaffBiographies() {
      cmsStaffBiographyService(sessionService.getAuthToken()).query(response => vm.staffBiographies = response);
    }

    function getStaffBiographiesSettings() {
      cmsStaffBiographiesSettingsService(sessionService.getAuthToken()).query(response => vm.staffBiographiesSettings = response);
    }

    function updateStaffBiographiesSettings() {
      cmsStaffBiographiesSettingsService(sessionService.getAuthToken()).update(vm.staffBiographiesSettings, _updateStaffBiographiesSettingsSuccess, _updateStaffBiographiesSettingsFailure);
    }

    function _updateStaffBiographiesSettingsSuccess(response) {
      vm.staffBiographiesSettings = response;
      Flash.create('success', 'Settings successfully updated.');
    }

    function _updateStaffBiographiesSettingsFailure(_error) {
      Flash.create('danger', 'An error occurred updating settings, please try again later.');
    }
  }
})();
